import { render, staticRenderFns } from "./activitiesDetail2026bj.vue?vue&type=template&id=70876e3b&scoped=true"
import script from "./activitiesDetail2026bj.vue?vue&type=script&lang=js"
export * from "./activitiesDetail2026bj.vue?vue&type=script&lang=js"
import style0 from "./activitiesDetail2026bj.vue?vue&type=style&index=0&id=70876e3b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70876e3b",
  null
  
)

export default component.exports